// eslint-disable-next-line
import React from 'react';
import { Flex, Box, theme, Radio } from '@xometry/xometry_loft';

interface Props {
  newPaymentMethod: string;
  setNewPaymentMethod: (openState: string) => void;
}

const CreditCardMethods = (props: Props) => {
  const { newPaymentMethod, setNewPaymentMethod } = props;
  return (
    <Box>
      <Flex alignItems="flex-start" justifyContent="flex-start">
        <Radio
          checked={newPaymentMethod === 'stripe'}
          onChange={() => setNewPaymentMethod('stripe')}
          enterKeyHint="enter"
        />
        <Box marginLeft="9px">
          <Flex
            color={theme.colors.darkBlues[100]}
            fontSize={theme.fontSizes[2]}
            fontWeight={theme.fontWeights.semibold}
            lineHeight={theme.lineHeights[3]}
          >
            <Box marginRight={theme.space[1]}>Add a Debit or Credit Card</Box>
          </Flex>
        </Box>
      </Flex>
    </Box>
  );
};

export default CreditCardMethods;
